const SITE_KEY_PATTERN = /^0x[0-9A-Za-z_-]{10,}$/;

export const getCaptchaSiteKey = (): string => (process.env.REACT_APP_CAPTCHA_SITE_KEY || '').trim();

export const isCaptchaSiteKeyConfigured = (): boolean => {
  const siteKey = getCaptchaSiteKey();
  if (!siteKey) {
    return false;
  }

  if (siteKey.includes('<') || siteKey.includes('>')) {
    return false;
  }

  return SITE_KEY_PATTERN.test(siteKey);
};

